// @flow

const PIXEL_GAP = 2;

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const exceedGap = (prevSize: number, currSize: number): boolean => Math.abs(prevSize - currSize) > PIXEL_GAP;
